import { render, staticRenderFns } from "./InfosMedia.vue?vue&type=template&id=b38a8df4&scoped=true"
import script from "./InfosMedia.vue?vue&type=script&lang=js"
export * from "./InfosMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38a8df4",
  null
  
)

export default component.exports